var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { formatDispute, sortFunction } from '../../ui/patterns/DisputesTable/helpers';
import getDisputes from './getDisputes';
export var TRANSACTIONS_PAGE_SIZE = 50;
export var initialState = {
    disputes: [],
    disputesError: null,
    transactions: [],
    paginatedTransactions: [],
    currentSorter: 'postedDate',
    sorterOrder: {
        postedDate: 1,
        amount: 1,
        claimId: 1
    }
};
var allDisputesSlice = createSlice({
    name: 'allDisputes',
    initialState: initialState,
    reducers: {
        clearAllDisputesState: function () {
            return initialState;
        },
        loadMoreTransactions: function (state) {
            var transactions = state.transactions, paginatedTransactions = state.paginatedTransactions;
            var transactionsSize = transactions.length;
            var paginatedTransactionSize = paginatedTransactions.length;
            var nextPageSize = transactionsSize - paginatedTransactionSize >= TRANSACTIONS_PAGE_SIZE
                ? TRANSACTIONS_PAGE_SIZE
                : paginatedTransactionSize;
            state.paginatedTransactions = transactions.slice(0, paginatedTransactionSize + nextPageSize);
        },
        sortTransactions: function (state, action) {
            var _a;
            var transactions = state.transactions, paginatedTransactions = state.paginatedTransactions, sorterOrder = state.sorterOrder;
            var sorter = action.payload;
            state.currentSorter = sorter;
            state.sorterOrder = __assign(__assign({}, sorterOrder), (_a = {}, _a[sorter] = sorterOrder[sorter] * -1, _a));
            var sortedTransactions = transactions.sort(sortFunction(state.currentSorter, state.sorterOrder[state.currentSorter]));
            state.paginatedTransactions = sortedTransactions.slice(0, paginatedTransactions.length);
        }
    },
    extraReducers: function (builder) {
        builder.addCase(getDisputes.fulfilled, function (state, action) {
            var currentSorter = state.currentSorter, sorterOrder = state.sorterOrder;
            var disputes = action.payload;
            state.disputes = disputes;
            state.disputesError = null;
            var transactions = disputes
                .reduce(formatDispute, [])
                .sort(sortFunction(currentSorter, sorterOrder[currentSorter]));
            state.transactions = transactions;
            state.paginatedTransactions = transactions.slice(0, TRANSACTIONS_PAGE_SIZE);
        });
        builder.addCase(getDisputes.rejected, function (state, action) {
            var payload = action.payload;
            // eslint-disable-next-line no-console
            console.error(payload);
            state.disputesError = payload;
        });
    }
});
export var clearAllDisputesState = (_a = allDisputesSlice.actions, _a.clearAllDisputesState), loadMoreTransactions = _a.loadMoreTransactions, sortTransactions = _a.sortTransactions;
export default allDisputesSlice.reducer;
//# sourceMappingURL=allDisputes.slice.js.map